/*
 * File per la definizione dei filtri Angular.
 */
define([
    'angular'
],
    function (angular) {

        var commonFilters = angular.module('commonFilters', []);

        var tipoEquals = function (tipo, compare) {
            return tipo === compare;
        };

        //verifiche call-back
        commonFilters.filter('richiedente', [function () {
            return function (input) {
                return input != undefined && input.richiedente !== undefined && input.richiedente.codiceFiscale !== undefined;
            };
        }]);

        commonFilters.filter('convertiData', function () {
            return function (inputTime) {
                if (inputTime === undefined || inputTime === null) return "";
                var data = new Date(inputTime);
                var gg = "00" + data.getDate();
                gg = gg.substring(gg.length - 2);
                var mm = "00" + (data.getMonth() + 1);
                mm = mm.substring(mm.length - 2);
                var yyyy = data.getFullYear();
                return gg + "/" + mm + "/" + yyyy;
            };
        });

        commonFilters.filter('decodeSesso', function () {
            return function (input) {
                if (input === undefined) return "---";
                if (input === 'M') return "Maschio";
                if (input === 'F') return "Femmina";
                return "---";
            };
        });

        commonFilters.filter('prettyPrintId', function () {
            return function (input) {

                var text;
                //ricerca label
                var elem = angular.element("[for$=" + input + "]");
                if (elem.length > 0) {
                    try {
                        text = elem.text();
                    } catch (e) {
                        text = undefined;
                    }
                    if (input.indexOf('-riga-') > -1) {
                        text = text + " riga " + (input.split('-riga-')[1]);
                    }
                }
                if (text !== undefined) {
                    return text;
                }

                //	dichiarazione-sostitutiva = Dichiarazione sostitutiva
                if (input === undefined) return "";
                try {
                    var split = input.split("-");
                    var prettyPrinted = split[0].substring(0, 1).toUpperCase() + split[0].substring(1);
                    for (var i = 1; i < split.length; i++) {
                        var part = split[i];
                        prettyPrinted += " ";
                        prettyPrinted += part;
                    }
                    return prettyPrinted.trim();
                } catch (e) {
                    return input;
                }

            };
        });

        return commonFilters;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/filters/common-filters.js
// module id = 40
// module chunks = 1